// Resize remote stock images to sane dimensions for fast loading.
export const optImg = (url, w = 1200, q = 75) => {
  if (!url) return url;
  try {
    if (url.includes("images.unsplash.com")) {
      const u = new URL(url);
      u.searchParams.set("auto", "format");
      u.searchParams.set("fit", "crop");
      u.searchParams.set("w", String(w));
      u.searchParams.set("q", String(q));
      return u.toString();
    }
    if (url.includes("images.pexels.com")) {
      const sep = url.includes("?") ? "&" : "?";
      return `${url}${sep}auto=compress&cs=tinysrgb&w=${w}`;
    }
  } catch {
    return url;
  }
  return url;
};
